var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "transition",
        {
          attrs: { name: "welfareScale" },
          on: {
            "after-leave": function ($event) {
              return _vm.$emit("closed")
            },
          },
        },
        [
          _vm.showPop
            ? _c("div", { ref: "welScaleWrap", staticClass: "pwa-wrap" }, [
                _c("div", { staticClass: "install-pwa" }, [
                  _c("div", {
                    staticClass: "close",
                    on: {
                      click: function ($event) {
                        _vm.showPop = !_vm.showPop
                      },
                    },
                  }),
                  _c("div", { staticClass: "content" }, [
                    _c(
                      "div",
                      { staticClass: "install-title" },
                      [
                        _vm.isShow
                          ? _c("AutoFontSize", [
                              _vm._v(_vm._s(_vm.$t("title_install_bonus"))),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "txt-1" },
                      [
                        _vm.isShow
                          ? _c("AutoFontSize", [
                              _vm._v(_vm._s(_vm.$t("subtitle_install_bonus"))),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "txt-2" },
                      [
                        _vm.isShow
                          ? _c(
                              "AutoFontSize",
                              [
                                _c(
                                  "i18n",
                                  {
                                    staticClass: "txt",
                                    attrs: {
                                      path: "tips_install_bonus",
                                      tag: "span",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "colors",
                                        attrs: { slot: 0 },
                                        slot: 0,
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("title_install_bonus"))
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "award" }),
                    _vm.calcShowInstall
                      ? _c(
                          "div",
                          { staticClass: "btn", on: { click: _vm.goInstall } },
                          [_vm._v(_vm._s(_vm.$t("title_install_bonus")))]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }